import { Translate } from "react-admin";

export interface ErrorMessage {
    key: string;
    args: object
}

export class BusinessError implements ErrorMessage {
    key: string;
    args: object;
    constructor(key: string, args?: object) {
        this.key = key;
        this.args = args;
    }
}

export const checkErrors = (errors: ErrorMessage[], notify, translate: Translate) => {
    let isValid;
    if (!errors || errors.length === 0) {
        isValid = true;
    } else {
        isValid = false;
        let message = "";
        for (const error of errors) {
            message += `${translate(error.key, error.args)}\n`;
        }
        notify("resources.alreadyTranslate", {
            type: "error",
            messageArgs: { message }
        });

    }
    return isValid;
}